import React from 'react';
import CardForm from './CardForm';
import { CiMoneyBill } from 'react-icons/ci';
import { HiOutlineArrowPath } from 'react-icons/hi2';
import { TbArrowBarDown } from 'react-icons/tb';
import { TbArrowBarUp } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
const Container = styled.div`
 display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: nowrap;
 

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
`;

export default function CardDetails({
  nbrTransactions,
  nbrEntree,
  nbrSortie,
  solde_total,
}) {
  const navigate = useNavigate();
  const ToEntry = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop();
    const newPath = [...pathSegments, `ventes/`].join('/');
    navigate(newPath);
  };
  const ToSorties = () => {
    let currentPath = window.location.pathname;
    currentPath = currentPath.replace(/\/+$/, '');
    const pathSegments = currentPath.split('/');
    pathSegments.pop();
    const newPath = [...pathSegments, `depenses/`].join('/');
    navigate(newPath);
  };
  return (
    <div>
      <Container>
        <CardForm
          explain={'Solde Total disponible'}
          somme={solde_total}
          icon={<CiMoneyBill />}
          color={'bg-success-subtle'}
          colorIcon={'text-success'}
          monnaie={" FCFA"}
        />
        <CardForm
          somme={nbrEntree}
          explain={'Nombre Totale des entrées'}
          icon={<TbArrowBarDown />}
          color={'bg-info-subtle'}
          colorIcon={'text-info'}
          onClick={ToEntry}
          monnaie={""}
        />
        <CardForm
          somme={nbrSortie}
          explain={'Nombre Totale des sorties'}
          icon={<TbArrowBarUp />}
          color={'bg-danger-subtle'}
          colorIcon={'text-danger'}
          onClick={ToSorties}
          monnaie={""}
        />
        <CardForm
          somme={nbrTransactions}
          explain={'Nombre de transactions'}
          icon={<HiOutlineArrowPath />}
          color={'bg-warning-subtle'}
          colorIcon={'text-warning'}
          monnaie={""}
        />
      </Container>
    </div>
  );
}
